import { Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import AdminDashboardSmallerStats from '../Admin Dashboards/AdminDashboardSmallerStats';
import UserDashboardSmallerStats from '../User Dashboards/UserDashboardSmallerStats';
import UserRole from '../../../../shared/AuthRoles';
import ReservationsCard from './ReservationsCard';
import MessagingCard from './MessagingCard';
import ContractorStats from '../Contractor Dashboard/ContractorStats';
import ContractorComponents from '../Contractor Dashboard/ContractorComponents';
import {
    AdminRole,
    ContractorRole,
    GuestRole,
    OwnerRole,
} from '../../../enums/users';
import { Period } from '../../../enums/reports';
import JobsCard from './JobsCard';
import ActivityCard from './ActivityCard';

const Dashboard = () => {
    const loggedInUser = UserRole();
    const [activityPeriod, setActivityPeriod] = useState(Period.CurrentWeek);

    return (
        <>
            <Typography
                variant='h1'
                sx={{
                    textAlign: 'left',
                    textTransform: 'uppercase',
                }}
            >
                Dashboard
            </Typography>
            <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
                {loggedInUser?.role === AdminRole.Admin && (
                    <Grid item xs={12}>
                        <ActivityCard
                            period={activityPeriod}
                            onPeriodChange={setActivityPeriod}
                        />
                    </Grid>
                )}
                <Grid item container xs={12} spacing={2}>
                    {loggedInUser?.role === ContractorRole.Admin ? (
                        <ContractorStats />
                    ) : loggedInUser?.role.includes('admin') ||
                      loggedInUser?.role === OwnerRole.User ? (
                        <AdminDashboardSmallerStats period={activityPeriod} />
                    ) : (
                        <UserDashboardSmallerStats />
                    )}
                </Grid>
                {[
                    GuestRole.Admin,
                    GuestRole.DepartmentAdmin,
                    OwnerRole.User,
                    OwnerRole.Admin,
                ].includes(loggedInUser?.role) && (
                    <>
                        <Grid
                            item
                            xs={12}
                            lg={loggedInUser?.role.includes('owner') ? 8 : 12}
                        >
                            <ActivityCard />
                        </Grid>
                        {loggedInUser?.role.includes('owner') && (
                            <Grid item xs={12} lg={4}>
                                <JobsCard />
                            </Grid>
                        )}
                    </>
                )}
                <Grid
                    item
                    xs={12}
                    lg={loggedInUser?.role === AdminRole.Admin ? 12 : 8}
                >
                    {loggedInUser?.role === ContractorRole.Admin ? (
                        <ContractorComponents />
                    ) : (
                        <ReservationsCard />
                    )}
                </Grid>
                {loggedInUser?.role !== AdminRole.Admin && (
                    <Grid item xs={12} lg={4}>
                        <MessagingCard />
                    </Grid>
                )}
            </Grid>
        </>
    );
};

export default Dashboard;
